import { STUDY_STATUS, isCardioOneFacility } from '@/entities/study';
import { copyTableIcon, moreIcon, trashTableIcon } from '@/shared/ui/assets';
import { CustomTooltip } from '@/shared/ui/components';

import { getParentNode } from '@/shared/lib';
import { Button, Popover } from 'antd';
import { t } from 'ttag';
import { useMoreOptionsPopover } from './useMoreOptionsPopover';
import type { MoreOptionsPopoverProps } from './moreOptionsPopover.types';

const MoreOptionsPopover = ({
  data,
  supportFacilities = [],
  onClickCopyStudy,
  toggleDisplayConfirmDeleteStudiesModal,
}: MoreOptionsPopoverProps) => {
  const { open, hide, handleOpenChange } = useMoreOptionsPopover();

  return (
    <CustomTooltip
      title={t`More options`}
      getPopupContainer={(ele) => getParentNode(ele, 5)}
      placement="bottomRight"
      classNames={{ root: 'tooltip-more-option' }}
    >
      <Popover
        placement="bottomRight"
        content={
          <div style={{ width: 150 }}>
            {!isCardioOneFacility(data.facility?.id, supportFacilities) && (
              <Button
                className="btn-with-icon"
                block
                type="text"
                onClick={() => {
                  hide();
                  onClickCopyStudy(data.id);
                }}
              >
                <img src={copyTableIcon} alt="copyTableIcon" />
                {t`Copy study`}
              </Button>
            )}
            {data.status !== STUDY_STATUS.ABORTED && (
              <Button
                className="btn-with-icon"
                block
                type="text"
                onClick={() => {
                  hide();
                  toggleDisplayConfirmDeleteStudiesModal([data.id], true, true);
                }}
              >
                <img src={trashTableIcon} alt="trashTableIcon" width={16} height={16} />
                {t`Delete study`}
              </Button>
            )}
          </div>
        }
        arrow={false}
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
      >
        <Button type="text" aria-label={t`More options`}>
          <img src={moreIcon} alt="moreIcon" />
        </Button>
      </Popover>
    </CustomTooltip>
  );
};

export default MoreOptionsPopover;
